export default __webpack_public_path__ + "static/media/36I-114290_-21026_0.587ee412.jpg";